const UserList = () => import("@/pages/auth/user/index.vue");
const UserForm = () => import("@/pages/auth/user/form.vue");

export default [
  {
    path: "/auth/user",
    component: UserList,
    meta: [
      {
        name: "权限管理",
		activeRoute: '/auth/manage'
      },
      {
        name: "管理员列表",
        activeRoute: "/auth/user",
      },
    ],
  },
  {
    path: "/auth/user/form",
    component: UserForm,
    meta: [
      {
        name: "权限管理",
		activeRoute: '/auth/manage'
      },
      {
        name: "管理员列表",
        url: "/auth/user",
      },
      {
        name: "新增/编辑",
        activeRoute: "/auth/user",
      },
    ],
  },
];
